import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getUserMutationKey } from '.';
import { userService } from '../../application/UserService';
import { UserActionType } from '../../context/user/actions';
import { useUserContext } from '../../context/user/context';
import { useShowSnackbarMessage } from '../snackbarMessage/useShowSnackbarMessage';

interface UseValidateUserPhoneProps {
  otp_code: string;
}

type UseValidateUserPhoneResponse = ServiceResponse<({ otp_code }: UseValidateUserPhoneProps) => void, void>;

// Hooks act as 'Adapter' layer.
const useValidateUserPhone = (): UseValidateUserPhoneResponse => {
  const { showSnackbarMessage } = useShowSnackbarMessage();
  const { userState, userDispatch } = useUserContext();
  const queryClient = useQueryClient();

  const { isLoading, isSuccess, isError, mutate } = useMutation(
    ({ otp_code }: UseValidateUserPhoneProps): Promise<void> => userService.validatePhone({ otp_code }),
    {
      onSuccess: (data) => {
        const newUser = userState.user!;

        newUser.phone_validated = true;

        userDispatch({
          type: UserActionType.UPDATE_USER_SUCCESS,
          payload: { user: newUser },
        });

        queryClient.invalidateQueries(getUserMutationKey());
      },
      onError: (err: any) => {
        console.info(`Validate User Phone Error: `, err?.response);

        showSnackbarMessage({
          messageIntlId: `infoerror.${err?.response?.data?.messageId ?? `network_error`}`,
        });
      },
    }
  );

  return {
    success: isSuccess,
    error: isError,
    isLoading,
    run: ({ otp_code }: UseValidateUserPhoneProps) => mutate({ otp_code }),
  };
};

export default useValidateUserPhone;
